var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('refresh',{attrs:{"type":"discount"}},[_c('rollbox',{ref:"rollbox",attrs:{"offText":_vm.transify['CHANGE_OFF']},on:{"startReel":function($event){_vm.$bus.drawing=true},"stopReel":function($event){_vm.$bus.drawing=false}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7a08d46","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/discount-refresh/discount-refresh.vue
// module id = null
// module chunks = 